// extracted by mini-css-extract-plugin
module.exports = {"stepperVague":"style_stepperVague__1d-rE","stepperVague_chevronLeft":"style_stepperVague_chevronLeft__24mcJ","stepperVague_chevronRight":"style_stepperVague_chevronRight__tiMvs"};